export const GET_STUDENT_THIRD_PARTY_APP_CREDENTIALS_QUERY = `
  query GetStudentThirdPartyAppCredentials($appName: String!) {
    getStudentThirdPartyAppCredentials(appName: $appName) {
      appName
      username
      password
    }
  }
`;
